<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      门店管理
      <small>/&nbsp;页面分区配置</small>
    </h1>
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">页面分区列表</h4>
              </div>
              <!-- end panel-heading -->

              <!-- begin panel-body -->
              <div class="panel-body">
                <form style="margin-top:16px;padding-left:15px;">
                  <fieldset>
                    <div class="form-group row m-b-15">
                      <label class="col-md-1 col-form-label">关键字</label>
                      <div class="col-md-2">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="分区名称/商品名称"
                          v-model="fuzzy"
                        >
                      </div>

                      <div class="col-md-1">
                        <a class="btn btn-primary ButtonColor m-r-5" @click="SearchClick">查询</a>
                      </div>
                    </div>
                  </fieldset>
                </form>
                <div style="text-align:right;margin-bottom:20px;">
                  <a
                    class="btn btn-primary ButtonColor"
                    @click="AddClick()"
                  >新增</a>
                </div>
                <el-table :data="UserManagementList" border style="width: 100%">
                  <el-table-column prop="ordernumber" label="序号" width="60" align="center"></el-table-column>
                  <el-table-column prop="recomName" label="服务商名称" align="center"></el-table-column>
                  <el-table-column prop="areaId" label="分区编号" align="center"></el-table-column>
                  <el-table-column prop="areaName" label="分区名称" align="center"></el-table-column>
                  <el-table-column prop="weights" label="权重" align="center"></el-table-column>
                  <el-table-column label="操作" width="240" align="center">
                    <template slot-scope="scope">
                      <button
                        class="btn btn-primary btn-sm ButtonColor"
                        @click="RelevantClick(scope.row)"
                      >关联商品</button>
                      <button
                        class="btn btn-primary btn-sm ButtonColor"
                        @click="EditClick(scope.row)"
                      >编辑</button>
                      <button
                        class="btn btn-warning btn-sm ButtonColor"
                        @click="DeleteClick(scope.row)"
                      >删除</button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="PaginationStyle">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageindex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="totalCount"
                  ></el-pagination>
                </div>
              </div>
              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
    <el-dialog title :visible.sync="outerVisible" width="500px" :before-close="handleClose">
      <div v-if="EditDialog === 2" class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">您确定删除吗?</div>
        <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <div class="swal-button-container">
              <button
                class="swal-button swal-button--confirm btn btn-primary"
                @click="MakeSure"
                :disabled="disabled"
              >确定</button>
            </div>
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
      <div v-if="EditDialog === 1" class="ModelPadding">
        <div class="swal-title" style="margin-top:0px">{{DialogTitle}}</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="150px"
          class="demo-ruleForm"
          style="width:90%"
        >
          <el-form-item label="分区名称:" prop="areaName">
            <el-input v-model="ruleForm.areaName" placeholder="分区名称" class="DistributorMargin"></el-input>
          </el-form-item>
          <el-form-item label="权重:" prop="weights">
            <el-input v-model.number="ruleForm.weights" placeholder="权重" class="DistributorMargin"></el-input>
          </el-form-item>
        </el-form>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureEdit('ruleForm')"
              :disabled="disabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <span>您当前正在使用默认分区配置，是否创建自己的分区？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAdd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
export default {
  name: "LogoManagement",
  data() {
    var checkweights = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("权重不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("请输入正整数"));
        } else {
          if (value <= 0) {
            callback(new Error("必须大于0"));
          } else {
            callback();
          }
        }
      }, 1000);
    };
    return {
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      value1: "",
      formdata: {},
      outerVisible: false,
      CheckedShow: true,
      disabled: false,
      BrandList: [],
      DialogTitle: "编辑",
      EditDialog: 1,
      CurrentSelection: [],
      fuzzy: "",
      StateOptions: [
        {
          label: "删除",
          value: 0
        },
        {
          label: "正常",
          value: 1
        }
      ],
      ruleForm: {},
      rules: {
        areaName: [{ required: true, message: "分区名称不能为空" }],
        weights: [{ required: true, validator: checkweights, trigger: "blur" }]
      },
      UserManagementEdit: "",
      TimeValue: "",
      UserManagementList: [],
      currentPage: 1,
      recom_id: "",
      shop_id:'',
      dialogVisible: false
    };
  },
  mounted: function() {
    if(this.$route.query.recomId){
      this.recom_id = this.$route.query.recomId;
    }
    if(this.$route.query.shopId){
      this.shop_id = this.$route.query.shopId;
    }
    this.initdata();
  },
  watch: {
    pageNo: {
      handler(newName, oldName) {
        if (this.$route.params) {
          this.pageNo = this.$route.params.pageNo;
        }
      },
      immediate: true
    }
  },
  computed: {
    pageNo: {
      set(val) {
        if (val) {
          this.pageindex = val;
        }
      },
      get() {
        //console.log('我被调用了') //msg1获取值时触发
      }
    }
  },
  methods: {
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    SearchClick() {
      this.initdata();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },
    RelevantClick(row) {
      this.$router.push({ 
        path:'/o2oassociatedgoods',
        name:'O2OAssociatedGoods',
        query: {recomId:this.recom_id,shopId:this.shop_id}
      });
      localStorage.setItem(
        "associatedgoods",
        JSON.stringify({
          areaId: row.areaId,
          pageNo: this.pageindex,
          pageSize: this.pageSize
        })
      );
    },
    DeleteClick(item) {
      this.outerVisible = true;
      this.EditDialog = 2;
      this.CurrentSelection = item;
    },
    AddClick() {
      this.ruleForm = {};
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.outerVisible = true;
      if (this.$refs.statusip != undefined) {
        this.$refs.statusip.$emit("clear");
      }
      this.DialogTitle = "新增";
      this.EditDialog = 1;
    },
    SearchClick() {
      this.pageindex = 1;
      this.initdata();
    },
    EditClick(row) {
      this.outerVisible = true;

      this.DialogTitle = "编辑";
      this.EditDialog = 1;
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.ruleForm = MethodsBus.cloneRow(row);
    },
    MakeSureEdit(formName) {
      let that = this;
      if (this.DialogTitle === "新增") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true;
            const options = {
              url: "distribution/B2cMarketAreaController/addShopArea",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                confirm: 0,
                recomId: that.recom_id,
                shopId: that.shop_id,
                areaName: that.ruleForm.areaName,
                weights: that.ruleForm.weights
              })
            };
            axios(options)
              .then(function(response) {
                that.outerVisible = false;
                that.disabled = false;
                if (response.data.code == 200) {
                  if(response.data.message == '新增成功'){
                    that.initdata();
                    that.$notify({
                      title: "成功",
                      message: response.data.message,
                      type: "success"
                    });
                  }else{
                    that.dialogVisible = true;
                  }
                } else {
                    http.handleEorrorCode(response,that);
                }
              })
              .catch(function(error) {
                that.outerVisible = false;
                that.disabled = false;
                http.handleHttpError(error, that);
              });
          } else {
            this.outerVisible = true;
          }
        });
      } else if (this.DialogTitle === "编辑") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true;
            const options = {
              url: "distribution/B2cMarketAreaController/updateShopArea",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                confirm: 0,
                recomId: that.recom_id,
                shopId: that.shop_id,
                areaId: that.ruleForm.areaId,
                areaName: that.ruleForm.areaName,
                weights: that.ruleForm.weights
              })
            };
            axios(options)
              .then(function(response) {
                that.outerVisible = false;
                that.disabled = false;
                if (response.data.code == 200) {
                  if(response.data.message == '修改成功'){
                    that.initdata();
                    that.$notify({
                      title: "修改",
                      message: response.data.message,
                      type: "success"
                    });
                  }else{
                    that.dialogVisible = true;
                  }
                } else {
                   http.handleEorrorCode(response,that);
                }
              })
              .catch(function(error) {
                that.outerVisible = false;
                that.disabled = false;
                http.handleHttpError(error, that);
              });
          } else {
            this.outerVisible = true;
          }
        });
      }
    },
    confirmAdd(){
      let that = this;
      if (this.DialogTitle === "编辑") {
        const options = {
          url: "distribution/B2cMarketAreaController/updateShopArea",
          method: "post",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          data: Qs.stringify({
            confirm: 1,
            recomId: that.recom_id,
            shopId: that.shop_id,
            areaId: that.ruleForm.areaId,
            areaName: that.ruleForm.areaName,
            weights: that.ruleForm.weights
          })
        };
        axios(options).then(function(response) {
          that.outerVisible = false;
          that.disabled = false;
          if (response.data.code === 200) {
            that.dialogVisible = false;
            that.initdata();
            that.$notify({
              title: "成功",
              message: response.data.message,
              type: "success"
            });
          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
      }else if(this.DialogTitle === "新增"){
        const options = {
          url: "distribution/B2cMarketAreaController/addShopArea",
          method: "post",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          data: Qs.stringify({
            confirm: 1,
            recomId: that.recom_id,
            shopId: that.shop_id,
            areaName: that.ruleForm.areaName,
            weights: that.ruleForm.weights
          })
        };
        axios(options)
          .then(function(response) {
            if (response.data.code == 200) {
              that.dialogVisible = false;
              that.initdata();
              that.$notify({
                title: "成功",
                message: response.data.message,
                type: "success"
              });
            } else {
              http.handleEorrorCode(response,that);
            }
          })
          .catch(function(error) {
            http.handleHttpError(error, that);
          });
      }
    },
    MakeSure() {
      let that = this;
      that.disabled = true;
      const options = {
        url: "distribution/B2cMarketAreaController/delShopArea",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          recomId: that.recom_id,
          shopId: that.shop_id,
          areaId: that.CurrentSelection.areaId
        })
      };
      axios(options)
        .then(function(response) {
          that.outerVisible = false;
          that.disabled = false;
          if (response.data.code == 200) {
            that.initdata();
            that.$notify({
              title: "成功",
              message: "删除成功",
              type: "success"
            });
          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          that.outerVisible = false;
          that.disabled = false;
          http.handleHttpError(error, that);
        });
    },
    initdata() {
      let that = this;
      const options = {
        url: "distribution/B2cMarketAreaController/queryShopArea",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          recomId: that.recom_id,
          shopId: that.shop_id,
          size: that.pageSize,
          current: that.pageindex,
          fuzzy: that.fuzzy
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.totalCount = response.data.data.total;
            for (var i in response.data.data.records) {
              response.data.data.records[i].ordernumber =
                Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;
              if (response.data.data.records[i].status === 0) {
                response.data.data.records[i].currentstatus = "删除";
                response.data.data.records[i].disabled = true;
              } else if (response.data.data.records[i].status === 1) {
                response.data.data.records[i].currentstatus = "正常";
                response.data.data.records[i].disabled = false;
              }
            }
            that.UserManagementList = response.data.data.records;
          } else {
              http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.LogoImg {
  width: 100px;
  height: 100px;
}
.BrandTitle {
  width: 30%;
  float: left;
  list-style: none;
  color: #909399;
  font-size: 16px;
  line-height: 56px;
  height: 56px;
  font-weight: 400;
}
.BrandTitleCheck {
  width: 30%;
  float: left;
  list-style: none;
  line-height: 56px;
  height: 56px;
}
.BrandTitleUl {
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 0px;
}
.BrandContent {
  width: 30%;
  float: left;
  list-style: none;
  font-size: 14px;
  color: #606266;
  height: 48px;
  line-height: 48px;
}
.CheckImg {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/O2OShopSetting/O2OPageManagement.vue